import { render, staticRenderFns } from "./DetalleProveedor.vue?vue&type=template&id=34992b3f&scoped=true"
import script from "./DetalleProveedor.vue?vue&type=script&lang=js"
export * from "./DetalleProveedor.vue?vue&type=script&lang=js"
import style0 from "./DetalleProveedor.vue?vue&type=style&index=0&id=34992b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34992b3f",
  null
  
)

export default component.exports